import $ from './el.JsModules.js';

elabs.ShopTheRoom = class {
  'use strict';

  constructor(element) {
    this.view = $(element);
    this.container = this.view.find('[data-container]')[0];
    const customRoomsAttr = this.view.data('custom-rooms-is-visible');
    this.isCustomRoomsVisible = customRoomsAttr === true || customRoomsAttr === 'true';
  }

  getRandomRooms(rooms) {
    const sectionId = this.view.data('section-id');
    let lastRoomIndex = +localStorage.getItem(`${sectionId}--last-room`) || 1;

    if (rooms.length === 1) {
      return 1;
    }

    let randomIndex;
    do {
      randomIndex = Math.floor(Math.random() * rooms.length) + 1;
    } while (randomIndex === lastRoomIndex);

    localStorage.setItem(`${sectionId}--last-room`, randomIndex);
    return randomIndex;
  }

  async init() {
    let rooms;

    if (this.isCustomRoomsVisible) {
      const customRoomsContainer = this.view.find('.el-shop-the-room__custom-rooms')[0];
      rooms = this.view
        .find('.el-shop-the-room__item')
        .toArray()
        .map((el) => el.cloneNode(true));
      if (customRoomsContainer) {
        customRoomsContainer.remove();
      }
    } else {
      const url = this.view.data('request-url');
      if (!url) {
        console.warn(`[ShopTheRoom] No request-url found for section ${this.view.data('section-id')}`);
        return;
      }

      const htmlDoc = await this.getDataFromPage(url);
      if (!htmlDoc) return;

      rooms = htmlDoc.querySelectorAll('.el-shop-the-room__item');
    }

    if (!rooms || rooms.length === 0) {
      console.warn(`[ShopTheRoom] No rooms found in section ${this.view.data('section-id')}`);
      this.view.closest('section').hide();
      return;
    }

    const index = this.getRandomRooms(rooms);
    const targetRoom = rooms[index - 1];

    if (!targetRoom) {
      console.error(`[ShopTheRoom] Could not find room with index ${index}`);
      return;
    }

    this.container.innerHTML = '';
    this.container.appendChild(targetRoom.cloneNode(true));

    elabs.Bootstrap.initialiseTooltips('.el-shop-the-room__bullet');
  }

  async getDataFromPage(url) {
    try {
      const resText = await fetch(url);
      const html = await resText.text();
      const parser = new DOMParser();
      return parser.parseFromString(html, 'text/html');
    } catch (e) {
      console.error('Error in el.ShopTheRoom.js', e);
    }
  }
};

// Init
async function initShopTheRoom() {
  const elements = $('.el-shop-the-room');
  for (let element of elements) {
    const instance = new elabs.ShopTheRoom(element);
    await instance.init();
  }
}

elabs.onJavascriptReady(function () {
  initShopTheRoom();
});
